export type SummaryType = "summary" | "snapshot";

export enum DocListMode {
  VIEW = "VIEW",
  EDIT = "EDIT",
  EXPORT = "EXPORT",
  SEARCH = "SEARCH",
}

export type PageInfo = {
  id: string;
  pageNumber: number;
  sectionId: string;
  index: number;
  pageImg: string | null;
};

export type CategoryItem = {
  id: number;
  name: string;
  isUnsaved: boolean;
  color: string;
  isFallback?: boolean;
};

export type Hint = {
  term: string;
  definition: string;
};
